// Next grid boundary from the value in the given direction — the same
// boundary set the canvas renders as dots and snapToGrid targets: cell starts
// at k*(step+gap) and, with a gap, also cell ends (start+step). A value
// already sitting on a boundary moves to the next one. Returns the value
// unchanged for a non-positive step (no grid to walk).
export const snapToGridInDirection = (
  value: number,
  step: number,
  gap: number,
  direction: 1 | -1
): number => {
  if (!step || step <= 0) {
    return value;
  }

  const period = step + Math.max(0, gap);
  const cell = Math.floor(value / period);
  const candidates: number[] = [];

  for (let k = cell - 1; k <= cell + 1; k += 1) {
    candidates.push(k * period);
    if (gap > 0) {
      candidates.push(k * period + step);
    }
  }

  const inDirection = candidates.filter((candidate) =>
    direction === 1 ? candidate > value : candidate < value
  );

  if (inDirection.length === 0) {
    return value;
  }

  return direction === 1 ? Math.min(...inDirection) : Math.max(...inDirection);
};
